import { render, staticRenderFns } from "./ManageDelivery.vue?vue&type=template&id=4be024ae&scoped=true"
import script from "./ManageDelivery.vue?vue&type=script&lang=js"
export * from "./ManageDelivery.vue?vue&type=script&lang=js"
import style0 from "./ManageDelivery.vue?vue&type=style&index=0&id=4be024ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be024ae",
  null
  
)

export default component.exports